export default __webpack_public_path__ + "clientapp/media/robot-08.876e4366.png";